export default __webpack_public_path__ + "static/FeijoaWeb-MediumItalic-08a7e684c9bff08b3af965f6fd4503a8.eot";